import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import GallerySection from "./GallerySection";
import HeroSection from "./HeroSection";
import MetaPoolSection from "./MetaPoolSection";
import SocialMediaInfoSection from "./SocialMediaInfoSection";
import NftArrivals from "../NftMarket/NftMarketPage/NftArrivals";

import environmentVariables from "../../config/environmentVariables";
import { userBalanceContext } from "../../context/userBalanceContext";
import axios from "axios";
import { userInfoContext } from "../../context/userInfoContext";

const Root = styled.div``;
const Container = styled.div`
  width: 80%;
  margin: 0 auto;
  padding-bottom: 50px;
  @media (max-width: ${(p) => p.theme.screen.lg}) {
    width: 90%;
  }
  @media (max-width: ${(p) => p.theme.screen.md}) {
    width: calc(100% - 40px);
  }
`;
const Home = (props) => {
  const { setUserBalance } = useContext(userBalanceContext);

  const {userAccInfo, setUserAccInfo}=useContext(userInfoContext)

  const getUserBalance = (address) => {
    setUserBalance(prev=>({...prev,loading:true}))
    axios
      .get(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/getuserbalance/${address}`,
        {headers:{
          authorization:`Bearer ${userAccInfo}`
        }}
      )
      .then((res) => {
        // console.log(res.data.data);
        const balance=res?.data?.data;
        if (res?.data?.success == true) 
          setUserBalance({
            MLDBalance: res?.data?.data?.MLDBalance || 0,
            LORDBalance: res?.data?.data?.LORDBalance || 0,
            MATICBalance: res?.data?.data?.MATICBalance || 0,
            USDTBalance: res?.data?.data?.USDTBalance || 0,
            MLD: res?.data?.data?.MLDBalanceDec || 0,
            LORD: res?.data?.data?.LORD || 0,
            MATIC: res?.data?.data?.MATIC || 0,
            USDT: res?.data?.data?.USDT || 0,
            LORDUSD: res?.data?.data?.LORDUSD || 0,
            MATICUSD: res?.data?.data?.MATICUSD || 0,
            MLDUSD: res?.data?.data?.MLDUSD || 0,
            MLDBalanceDec: res?.data?.data?.MLDBalanceDec || 0,
            LORDBalance: res?.data?.data?.LORDBalance || 0,
            loading:false,
          });
        else
          setUserBalance({
            MLDBalance: 0,
            LORDBalance: 0,
            MATICBalance: 0,
            USDTBalance: 0,
            MLD: 0,
            LORD: 0,
            MATIC: 0,
            USDT: 0,
            LORDUSD: 0,
            MATICUSD: 0,
            MLDUSD: 0,
            MLDBalanceDec: 0,
            LORDBalance: 0,
            loading:false,
          });
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    if (props?.allContractDetails) {
      getUserBalance(props?.allContractDetails?.address);
    }
  }, [props?.allContractDetails]);
  return (
    <Root>
      <HeroSection {...props} />
      <SocialMediaInfoSection />
      <GallerySection />
      <MetaPoolSection />
      <Container>
        <NftArrivals isHome={true} {...props} />
        {/* <ActiveUpcomingNft {...props} /> */}
      </Container>
    </Root>
  );
};

export default Home;
